import { render, staticRenderFns } from "./StocktakingView.vue?vue&type=template&id=c833901e&"
import script from "./StocktakingView.vue?vue&type=script&lang=js&"
export * from "./StocktakingView.vue?vue&type=script&lang=js&"
import style0 from "./StocktakingView.vue?vue&type=style&index=0&id=c833901e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports